module.exports = __webpack_public_path__ + "img/youtube-icon.673e27cc.svg";